<template>
    <div>
        <label
            class="card-checkbox text-base text-black leading-normal"
        >
            <input
                :name="name"
                type="checkbox"
                value="1"
                ref="checkbox"

                @input="update"
                @click="click"
            >
            <span>
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
    export default {
        props: ['name', 'value', 'checkedValue'],
        mounted() {
            this.$refs.checkbox.checked = this.value
        },
        watch: {
            value: {
                handler(value) {
                    this.$refs.checkbox.checked = value
                },
            }
        },
        methods: {
            update() {
                this.$emit('input', this.$refs.checkbox.checked)
            },
            click(e) {
                // Remove focus for mouse clicks for styling reasons
                if (! this.isKeyboardClick(e)) {
                    this.$refs.checkbox.blur()
                }
            },
            isKeyboardClick(e) {
                return e.screenX === 0 && e.screenY === 0
            }
        }
    }
</script>

<style lang="scss">

    .card-checkbox {
        z-index: 0;
        position: relative;
        display: inline-block;
        color: #707070;

        a {
            text-decoration: underline;
        }
    }

    /* Input */
    .card-checkbox > input {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        z-index: -1;
        position: absolute;
        left: -10px;
        top: -8px;
        display: block;
        margin: 0;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        background-color: rgba(0, 0, 0, 0.6);
        box-shadow: none;
        outline: none;
        opacity: 0;
        transform: scale(1);
        pointer-events: none;
        transition: opacity 0.3s, transform 0.2s;
    }

    /* Span */
    .card-checkbox > span {
        display: inline-block;
        width: calc(100% - 30px);
        cursor: pointer;
        text-indent: -30px;
        margin-left: 30px; // see text-ident on span element
    }

    /* Box */
    .card-checkbox > span::before {
        content: "";
        display: inline-block;
        box-sizing: border-box;
        margin: 3px 11px 3px 1px;
        border: solid 1px; /* Safari */
        border-color: #707070;
        border-radius: 5px;
        width: 18px;
        height: 18px;
        vertical-align: top;
        transition: border-color 0.2s, background-color 0.2s;
        margin-top: 0px;
    }
    .card-checkbox.card-checkbox-validation-error span::before {
        border-color: red;
    }

    /* Checkmark */
    .card-checkbox > span::after {
        content: "";
        display: block;
        position: absolute;
        top: 1px;
        left: 1px;
        width: 11px;
        height: 6px;
        border: solid 2px transparent;
        border-right: none;
        border-top: none;
        transform: translate(3px, 4px) rotate(-45deg);
    }

    /* Checked, Indeterminate */
    .card-checkbox > input:checked,
    .card-checkbox > input:indeterminate {
        //background-color: rgb(33, 150, 243);
        background-color: #1D5091;
    }

    .card-checkbox > input:checked + span::before,
    .card-checkbox > input:indeterminate + span::before {
        //border-color: rgb(33, 150, 243);
        //background-color: rgb(33, 150, 243);
        background-color: #1D5091;
        border-color: #1D5091;
    }

    .card-checkbox > input:checked + span::after,
    .card-checkbox > input:indeterminate + span::after {
        border-color: rgb(255, 255, 255);
    }

    .card-checkbox > input:indeterminate + span::after {
        border-left: none;
        transform: translate(4px, 3px);
    }

    /* Hover, Focus */
    .card-checkbox:hover > input {
        opacity: 0;
    }

    .card-checkbox > input:focus {
        opacity: 0.12;
    }

    .card-checkbox:hover > input:focus {
        opacity: 0.16;
    }

    /* Active */
    .card-checkbox > input:active {
        opacity: 1;
        transform: scale(0);
        transition: transform 0s, opacity 0s;
    }

    .card-checkbox > input:active + span::before {
        //border-color: rgb(33, 150, 243);
        border-color: #1D5091;
    }

    .card-checkbox > input:checked:active + span::before {
        border-color: transparent;
        background-color: rgba(0, 0, 0, 0.6);
    }

    /* Disabled */
    .card-checkbox > input:disabled {
        opacity: 0;
    }

    .card-checkbox > input:disabled + span {
        color: rgba(0, 0, 0, 0.38);
        cursor: initial;
    }

    .card-checkbox > input:disabled + span::before {
        border-color: currentColor;
    }

    .card-checkbox > input:checked:disabled + span::before,
    .card-checkbox > input:indeterminate:disabled + span::before {
        border-color: transparent;
        background-color: currentColor;
    }
</style>